import React, { useState } from "react";
import Drafts from "../Drafts";
import DraftsCollections from "../DraftsCollections";
import FiltersMenu from "../../../../shared/FiltersMenu/FiltersMenu";
import { DraftsTabContainer } from "./DraftTab.styled";

const options = ["recipes", "collections"];
const filterText = ["Recipes", "Collections"];

export const DraftsTab = () => {
  const [activeDraft, setActiveDraft] = useState("recipes");

  return (
    <DraftsTabContainer>
      <FiltersMenu
        filterText={filterText}
        filterOptions={options}
        activeFilterOption={activeDraft}
        setFilter={setActiveDraft}
      />

      {activeDraft === "recipes" ? <Drafts /> : <DraftsCollections />}
    </DraftsTabContainer>
  );
};
